/**
 * @description 全屏弹窗，但距离页面顶部的50px的弹窗
 */

import React, { Component } from 'react';
import { components } from 'common';
const { Button } = components;
import { throttle } from '@umu/umu-util';
import './coverPopPage.scss';

export interface ICoverPopPageProps {
    hideCloseBtn?: boolean;
    clsName?: string;
    onClose?(): void;
    hitBottomCallback?(): void;
}

function hitPanelBottom(offset: number = 180, targetEl?: Element, parentEl?: Element): boolean {
    let ret = false;
    if (!targetEl || !parentEl) {
        return ret;
    }

    const targetHeight = targetEl.clientHeight;
    const parentHeight = parentEl.clientHeight;
    const parentScrollTop = parentEl.scrollTop;

    if (parentHeight + parentScrollTop + offset >= targetHeight) {
        ret = true;
    }

    return ret;
}

class CoverPopPage<P extends ICoverPopPageProps, S> extends Component<P, S> {
    private parentRef?: HTMLElement;
    private contentRef?: HTMLElement;

    constructor(props: P) {
        super(props);

        this.bindEvent = this.bindEvent.bind(this);
        this.scrollEvent = throttle(this.scrollEvent.bind(this), 400);
    }

    public onClose = () => {
        const onClose = this.props.onClose;
        if (onClose) {
            onClose();
        }
    };

    public componentDidMount() {
        this.bindEvent();
    }

    public componentWillUnmount() {
        if (this.props.hitBottomCallback && this.parentRef) {
            this.parentRef.removeEventListener('scroll', this.scrollEvent, false);
        }
    }

    public bindEvent() {
        if (this.props.hitBottomCallback && this.parentRef) {
            this.parentRef.addEventListener('scroll', this.scrollEvent, false);
        }
    }

    public scrollEvent() {
        if (this.props.hitBottomCallback) {
            if (hitPanelBottom(180, this.contentRef, this.parentRef)) {
                this.props.hitBottomCallback();
            }
        }
    }

    public render() {
        const { clsName = '', hideCloseBtn, onClose } = this.props;
        return (
            <div className={'cover-pop-page ' + clsName}>
                <div className="cover-pop-page-mask" onClick={this.onClose}></div>
                <div
                    className="cover-pop-page-body"
                    ref={(ref) => {
                        this.parentRef = ref as HTMLElement;
                    }}
                >
                    <div
                        ref={(ref) => {
                            this.contentRef = ref as HTMLElement;
                        }}
                    >
                        {onClose && !hideCloseBtn ? (
                            <div className="cover-pop-page-action">
                                <div className="cover-pop-page-close">
                                    <Button alias="text" onClick={this.onClose}>
                                        <div className="icon-page-close"></div>
                                    </Button>
                                </div>
                            </div>
                        ) : null}
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }
}

export default CoverPopPage;
